import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import SingleWirePage, { getDefaultData } from "components/pages/SingleWirePage";
import Classes, { Account, Payee } from "model";
import { useEffect } from "react";
export default function CaptureSingleWireAccountSelected(props) {
  const context = useBCMSContext();
  
  const { branding } = context.state;
  BCMSRecord.globalControllerFor(Classes, context);
  let hasLOC = context.state.branding.options.loc_primary_abi22 == "true"; 
  let hasConsumer = context.state.branding.options.show_consumer_accts_abi22 == "true";  
  let locAccount = hasConsumer ? Account.initByID(9) :Account.initByID(10);
   let nonLocAccount = hasConsumer ? Account.initByID(1) :Account.initByID(5);
    let selectedAccount = hasLOC ? locAccount :nonLocAccount;
  const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update(["wire", "payee"], Payee.initByID(0))
    .update(["wire", "fundingAccount"], selectedAccount)
    .submit();
 useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

  return (
    <SingleWirePage data={data} />
  )
}
